// Shared metadata for deal product types — labels, colors, icons.
// Colors come from CSS tokens where possible to honour theme switch;
// product-specific accents (used as the **left stripe** of cards in
// Obchodní nástěnka) stay semantic per design (§7.5).

import {
  Home as HouseIcon, Briefcase, Shield, TrendingUp, Coins,
  Car, Building, CreditCard, HeartPulse, Box,
} from "lucide-react";

export const PRODUCT_META = {
  hypoteka:           { label: "Hypotéka",        short: "Hyp",   color: "#D2703E", icon: HouseIcon },
  refinancovani:      { label: "Refinancování",   short: "Refi",  color: "#A85632", icon: HouseIcon },
  podnikatelsky_uver: { label: "Podnikatelský úvěr", short: "PÚ",  color: "#B0492A", icon: Briefcase },
  spotrebitelsky_uver:{ label: "Spotřební úvěr",  short: "SÚ",    color: "#B0492A", icon: CreditCard },
  uver:               { label: "Úvěr",            short: "Úv",    color: "#B0492A", icon: CreditCard },
  pojisteni_zivot:    { label: "Životní",         short: "ŽP",    color: "#3F7ED0", icon: HeartPulse },
  pojisteni_auta:     { label: "Auto",            short: "Auto",  color: "#2B6CB0", icon: Car },
  pojisteni_majetek:  { label: "Majetek",         short: "Maj",   color: "#5466A8", icon: Building },
  investice:          { label: "Investice",       short: "Inv",   color: "#4CA24C", icon: TrendingUp },
  penzijko:           { label: "Penze",           short: "DPS",   color: "#D9A32E", icon: Coins },
  stavebni:           { label: "Stavební",        short: "St",    color: "#6E9A8E", icon: Shield },
  // Realitní obchody. Bez těchhle dvou řádků padaly na `jine` a makléř četl
  // u zakázky na svůj byt štítek „Jiné" — včetně šedivé barvy, kterou má
  // nástěnka rezervovanou pro „nezařazeno".
  prodej_nemovitosti: { label: "Prodej nemovitosti", short: "Prod", color: "#8A6F3E", icon: HouseIcon },
  koupe_nemovitosti:  { label: "Koupě nemovitosti",  short: "Koup", color: "#6E8A5E", icon: HouseIcon },
  jine:               { label: "Jiné",            short: "—",     color: "var(--muted)", icon: Box },
};

export const BOARD_COLUMNS = [
  // Inkoustové gradienty (ZADANI_1): hluboká gradientová hlavička + plná barva pro stage tracky.
  { id: "analyza", title: "Fin. analýza / Nabídnuto",  color: "#6D48B8", gradient: "linear-gradient(140deg, #6D48B8, #3F2A70)" },
  { id: "proces",  title: "Žádost / V procesu",         color: "#C74E22", gradient: "linear-gradient(140deg, #C74E22, #742A10)" },
  { id: "podpis",  title: "Schválení / Podpis",         color: "#D69412", gradient: "linear-gradient(140deg, #D69412, #7A5306)" },
  { id: "cerpani", title: "Čerpání / Čekám na provize", color: "#0FBF62", gradient: "linear-gradient(140deg, #0FBF62, #045E30)" },
];

export const productMeta = (pt) => PRODUCT_META[pt] || PRODUCT_META.jine;

// Provider monogram fallback — first 2 chars uppercased — when no logo is available.
// In production, replace with official partner logo assets (§7.9).
export const providerMonogram = (provider = "") => {
  const t = (provider || "").trim();
  if (!t) return "—";
  const parts = t.split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return t.slice(0, 2).toUpperCase();
};

// Locale parametrizovatelný (default cs-CZ), ať se dá volat s currency.locale (SK).
export const fmtCZ = (n, locale = "cs-CZ") => new Intl.NumberFormat(locale).format(Math.round(n || 0));
